import { render, staticRenderFns } from "./ErrorSubmitForm18.vue?vue&type=template&id=0fa107fb&scoped=true"
import script from "./ErrorSubmitForm18.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm18.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa107fb",
  null
  
)

export default component.exports